import { MESHBOT_NODE_TYPES } from 'constants/MeshbotConstant';
import { getTriggerBlockData } from './getTriggerBlockData';
import { buildUiGeofenceTriggerData } from './geofence';

/**
 * Converts a trigger block of type "IsDictionaryChanged" into a UI-compatible structure.
 *
 * If the block is a GEOFENCE type, it uses `buildUiGeofenceTriggerData` to construct the UI data.
 * Otherwise, logs an error and returns a null-result placeholder.
 *
 * @param {string} id - The ID of the trigger block.
 * @param {Object} block - The full trigger block from the meshbot config.
 * @param {Array<Object>} items - Controller items used for device/field mapping.
 * @param {Array<Object>} devices - Devices from the controller.
 * @returns {{
 *   triggersListBlock: Object | null,
 *   triggersSelectBlock: Object | null
 * }} A structured representation of the block for UI usage, or null values if unsupported.
 *
 * @example
 * convertIsDictionaryChangedBlockToUI('t1', triggerBlock, items, devices);
 */

export const convertIsDictionaryChangedBlockToUI = (id, block, items, devices) => {
    const triggerBlockData = getTriggerBlockData(block);

    if (triggerBlockData?.sourceData?.blockMeta?.nodeType === MESHBOT_NODE_TYPES.GEOFENCE) {
        return buildUiGeofenceTriggerData({
            id,
            items,
            devices,
            ...triggerBlockData,
        });
    }
    // eslint-disable-next-line no-console
    console.error("A case we don't know how to handle. We need a implementation");

    return { triggersListBlock: null, triggersSelectBlock: null };
};
